import React from 'react'
import AsyncApiComponent from "@asyncapi/react-component";
import "@asyncapi/react-component/styles/default.min.css";

export default function AsyncApi({ spec }) {

    if (!spec) return null;

    // console.log(JSON.stringify(spec))

    return (
        <div style={{ color: "black" }}>
            <AsyncApiComponent schema={spec} />
            {/* <AsyncApiComponent schema={spec} config={{
                expand: {
                    channels: {
                        root: true, elements: true
                    },
                    // servers: {
                    //     root: true
                    // }
                },
                // show: {
                //     info: true,
                //     channels: true,
                //     servers: true,
                //     messages: true,
                //     schemas: true,
                // }
            }} /> */}
        </div>

    )
}
